// extracted by mini-css-extract-plugin
module.exports = {"results":"results-module--results--XZ6-h","findings":"results-module--findings--26KYH","icon":"results-module--icon--2DhQY"};